import { CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { CatalogInterface } from '../../../interface/rank/catalog.interface'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

export const getCatalogsService = (cancelToken?: CancelToken) =>
  apiInstance.get<CatalogInterface[]>(ApiPathConfig.CATALOGS, {
    cancelToken,
  })
